import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const guarantees = ['Download istantaneo', 'Accesso a vita', 'Garanzia 7 giorni'];
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-bone" data-id="element-114" data-mp="4lysie31809y">
      <div className="bg-court absolute inset-0" aria-hidden="true" data-id="element-115" data-mp="4jm71qy2f7s5" />

      <div className="relative mx-auto max-w-5xl px-5 pb-16 pt-5 text-center lg:pb-20" data-id="element-116" data-mp="1285x3nzc5smb">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} className="inline-flex items-center gap-2.5 rounded-full border-2 border-ink bg-white px-4 py-2" data-id="element-117" data-mp="xbfi73z9p32h">
          <span className="flex items-center gap-0.5 text-brand" aria-hidden="true" data-id="element-118" data-mp="3d2labedjz91r">
            {Array.from({
            length: 5
          }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-current" data-id="element-119" data-mp="384s5oprwen3l" data-mpi={index} />)}
          </span>
          <span className="text-xs font-extrabold uppercase tracking-[0.12em] text-ink" data-id="element-120" data-mp="3j6g1bysfzti2">
            4.9/5 · +1.500 docenti
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: EASE
      }} className="balance mx-auto mt-7 max-w-3xl font-display text-[2.3rem] leading-[0.97] tracking-[-0.015em] text-ink sm:text-[3.2rem] lg:text-[4rem]" data-id="element-121" data-mp="399jmlbbyab52">
          Risolvi un intero anno di lezioni di Inglese in soli{' '}
          <span className="relative inline-block whitespace-nowrap text-brand" data-id="element-122" data-mp="2qhqtlgwvspxc">
            5 minuti
            <span className="absolute inset-x-0 -bottom-1 h-[0.12em] rounded-full bg-volt" aria-hidden="true" data-id="element-123" data-mp="2vgu0l6wf967y" />
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: EASE
      }} className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-ink/70 sm:text-lg" data-id="element-124" data-mp="2ll0dwuoznwcg">
          <span className="font-bold text-ink" data-id="element-125" data-mp="ibow6f6accrq">
            Basta bruciare intere domeniche a pianificare.
          </span>{' '}
          Ogni ora che perdi cercando materiali su Google o Pinterest non torna
          più: scarica, stampa ed entra in aula con la sicurezza di chi ha tutto
          pronto.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.18,
        ease: EASE
      }} className="relative mx-auto mt-4 w-full max-w-2xl" data-id="element-126" data-mp="163454qskhsby">
          <img src="https://cdn.magicpatterns.com/uploads/hnRvUZVWhsqQjgFCR8dJnG/8f0cb86b-871b-4d92-8ec8-425bda73a31f_(1).webp" alt="Il Kit Inglese Pronto: i sei volumi dal livello A1 al C2, i cinque bonus e la piattaforma digitale su monitor, tablet e smartphone" className="block w-full" data-id="element-127" data-mp="3lt756pxsnptq" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3,
        delay: 0.22,
        ease: EASE
      }} className="mx-auto mt-2 max-w-xl text-sm font-semibold leading-relaxed text-ink/60" data-id="element-128" data-mp="21bxx31tbem9r">
          6 volumi (A1 → C2) + Master Plan di Valutazione + 5 bonus.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.26,
        ease: EASE
      }} className="mt-6" data-id="element-129" data-mp="2kyvlvd5brmio">
          <CtaButton label="Voglio il mio Kit ora" href="#offer" className="w-full sm:w-auto" data-id="element-130" data-mp="2tztr1yri202u" />

          <ul className="mx-auto mt-6 flex max-w-2xl flex-wrap items-center justify-center gap-x-7 gap-y-3" data-id="element-131" data-mp="un9bbrw7qrh9">
            {guarantees.map(item => <li key={item} className="flex items-center gap-2 text-sm font-bold text-ink/75" data-id="element-132" data-mp="zlswvr6wa193">
                <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-volt" data-id="element-133" data-mp="49t5s073b8vi">
                  <CheckIcon className="h-3 w-3 text-ink" aria-hidden="true" strokeWidth={3} data-id="element-134" data-mp="3vhfei78o21j8" />
                </span>
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}